var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVoice = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 1.79999C17.1627 1.79999 17.7 2.33725 17.7 2.99999V21C17.7 21.6627 17.1627 22.2 16.5 22.2C15.8373 22.2 15.3 21.6627 15.3 21V2.99999C15.3 2.33725 15.8373 1.79999 16.5 1.79999ZM12 4.79999C12.6627 4.79999 13.2 5.33725 13.2 5.99999V18C13.2 18.6627 12.6627 19.2 12 19.2C11.3373 19.2 10.8 18.6627 10.8 18V5.99999C10.8 5.33725 11.3373 4.79999 12 4.79999ZM3 8.79999C3.66274 8.79999 4.2 9.33725 4.2 9.99999V14C4.2 14.6627 3.66274 15.2 3 15.2C2.33726 15.2 1.8 14.6627 1.8 14L1.8 9.99999C1.8 9.33725 2.33726 8.79999 3 8.79999ZM21 8.79999C21.6627 8.79999 22.2 9.33725 22.2 9.99999V14C22.2 14.6627 21.6627 15.2 21 15.2C20.3373 15.2 19.8 14.6627 19.8 14V9.99999C19.8 9.33725 20.3373 8.79999 21 8.79999ZM7.5 9.79999C8.16274 9.79999 8.7 10.3372 8.7 11V13C8.7 13.6627 8.16274 14.2 7.5 14.2C6.83726 14.2 6.3 13.6627 6.3 13V11C6.3 10.3372 6.83726 9.79999 7.5 9.79999Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVoice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Voice.5644c777c9f791dcd5bbd0ecd4f4a690.svg";